import type { ManifestLocale, UiCopy } from '../lib/types';

interface BrandHeaderProps {
  ui: UiCopy;
  locales: ManifestLocale[];
  localeCode: string;
  onLocaleChange: (locale: string) => void;
  onHome: () => void;
  showHome: boolean;
}

const SHORT_LABEL: Record<string, string> = {
  en: 'EN',
  'zh-CN': '中文',
  es: 'ES',
};

export function BrandHeader({
  ui,
  locales,
  localeCode,
  onLocaleChange,
  onHome,
  showHome,
}: BrandHeaderProps) {
  return (
    <header className="brand-header">
      {showHome ? (
        <button type="button" className="brand-lockup" onClick={onHome} aria-label={ui.assessment.changeRole}>
          <span className="brand-mark" aria-hidden="true" />
          <strong>{ui.brand.name}</strong>
        </button>
      ) : (
        <span className="brand-lockup">
          <span className="brand-mark" aria-hidden="true" />
          <strong>{ui.brand.name}</strong>
        </span>
      )}

      <div className="language-switch" role="group" aria-label={ui.brand.language}>
        {locales.map((locale) => (
          <button
            key={locale.code}
            type="button"
            lang={locale.htmlLang}
            className={locale.code === localeCode ? 'is-active' : ''}
            aria-pressed={locale.code === localeCode}
            onClick={() => onLocaleChange(locale.code)}
          >
            <span aria-hidden="true">{SHORT_LABEL[locale.code] ?? locale.code.toUpperCase()}</span>
            <span className="sr-only">{locale.label}</span>
          </button>
        ))}
      </div>
    </header>
  );
}
